import script from "./TicketView.vue?vue&type=script&lang=ts&setup=true"
export * from "./TicketView.vue?vue&type=script&lang=ts&setup=true"

import "./TicketView.vue?vue&type=style&index=0&id=62a01a4d&scoped=true&lang=css"

import exportComponent from "/builds/n-Zh5gRSP/0/batesbus/app.securechannel.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62a01a4d"]])

export default __exports__